import { unfolder, useTranslate } from '../../lib'

const ModeProject = ({open}) => { 
    const { t } = useTranslate();
    const role = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role

    return (
        <div className="newProject-modal mode-proj-modal modal-cont" style={{width: "100%"}}>
            <h1>{t('menu.createProject')}</h1>
            <p className="sub-title-gen">{t('menu.createProjectHow')}</p>
            <form className="w-100 mt-3 px-8">
                <div className="scroll-gen-modal mt-3" style={{height: "40vh"}} >
                    <div className="flex items-center justify-center">
                        {role == 6 && <button type="button" className="flex flex-col  btn-mode-project " onClick={()=>open('NLP')} >
                            <img src='/icons/manualsetup-projects-icon.svg' alt="" />
                            <div className="label-gen-btn  w-full" >{t('menu.setupStandard')}</div>
                        </button>}

                        {/* <button type="button" className="flex flex-col  btn-mode-project ml-5 " onClick={()=>open('GEN AI')}>
                            <img src='/icons/GenAI-projectgenerated-icon.svg' alt="" />
                            <div className="label-gen-btn  w-full" >{t('menu.usingGenAI')}</div>
                        </button> */}

                        <button type="button" className="flex flex-col  btn-mode-project ml-5 " onClick={()=>open('WIZARD')}>
                            <img src='/icons/GenAI-projectgenerated-icon.svg' alt="" />
                            <div className="label-gen-btn  w-full" >{t('menu.usingGenAI')}</div>
                        </button>   
                    </div>
                </div>
            </form>
            {/*<Button 
                label='Cerrar'
                
                className='buttonE'
            />*/}
        </div>
    )
}

export default ModeProject;